// src/portals/admin/components/monetization/AffiliateManager.js
import React, { useState } from "react";
import Button from "../../../../components/ui/Button";
import AdminDataTable from "../AdminDataTable";
import { Plus, Link } from "lucide-react";
import { useData } from "../../../../context/DataContext";
import CreateOpportunityModal from "../CreateOpportunityModal";

const AffiliateManager = () => {
  const { affiliates, addAffiliateDeal } = useData();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const affiliateColumns = [
    { header: "Product Name", key: "productName", render: (r) => <span className="font-medium text-slate-800">{r.productName}</span> },
    { header: "Vendor", key: "vendor" },
    { header: "Commission", key: "commission", render: (r) => <span className="font-medium text-green-600">{r.commission}</span> },
    { header: "Est. Sales", key: "sales", render: (r) => <span className="text-slate-600">{r.sales || 0}</span> },
    { header: "Active Links", key: "activeLinks", render: (r) => <span className="px-2 py-1 bg-purple-50 text-purple-600 rounded-full text-xs">{r.activeLinks || 0}</span> },
    { header: "Actions", key: "actions", render: () => <Button size="sm" variant="ghost">Details</Button> }
  ];

  const handleCreate = (data) => {
    addAffiliateDeal({
      id: Date.now(),
      productName: data.title,
      vendor: data.brand || "Internal",
      commission: data.paymentAmount || "10%",
      sales: 0,
      activeLinks: 0,
      imageUrl: "https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=100&h=100&fit=crop",
      ...data
    });
    setIsModalOpen(false);
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h3 className="text-lg font-bold text-slate-700">Affiliate Products</h3>
        <Button onClick={() => setIsModalOpen(true)}><Plus className="w-4 h-4 mr-2" /> New Deal</Button>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
         <div className="p-4 bg-purple-50 rounded-xl border border-purple-100 flex items-center justify-between">
            <div>
               <div className="text-sm text-purple-600 mb-1">Total Sales Generated</div>
               <div className="text-2xl font-bold text-slate-800">1.2M ETB</div>
            </div>
            <Link className="text-purple-300" size={32} />
         </div>
         {/* More stats can go here */}
      </div>

      <AdminDataTable 
        columns={affiliateColumns.map(c => ({...c, sortable: true}))} 
        data={affiliates}
        searchableFields={["productName", "vendor"]}
      />

      {isModalOpen && (
        <CreateOpportunityModal 
          isOpen={isModalOpen} 
          onClose={() => setIsModalOpen(false)} 
          type="affiliate"
          onSave={handleCreate}
        />
      )}
    </div>
  );
};

export default AffiliateManager;
